import React from 'react';

const Terms = () => {
    return (
        <div className="terms-container max-w-4xl mx-auto p-6 bg-background text-white">
            <div className="terms-content">
                <h1 className="text-4xl font-bold mb-4">Terms and Conditions</h1>

                <p className="text-text-light mb-6"><em>Last updated: July 31, 2025</em></p>

                <p className="mb-6">Welcome to our website. By accessing or using this site, you agree to these Terms and Conditions ("Terms"). Please read them carefully.</p>

                <h2 className="text-2xl font-bold mb-4 text-primary">1. Use of Our Site</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>You must comply with these Terms and all applicable laws.</li>
                    <li>You agree not to misuse the site or engage in harmful or illegal activity.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">2. Intellectual Property</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We retain all rights to the site's content, software, and trademarks.</li>
                    <li>You may not reproduce or distribute any content without our permission, except where allowed by law.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">3. User Content</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>You are responsible for any content you submit. Do not post unlawful, harmful, or infringing material.</li>
                    <li>We may remove or moderate content that violates these Terms.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">4. Disclaimer</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>The site is provided "as is" without warranties. We do not guarantee it will be error-free or uninterrupted.</li>
                    <li>We are not responsible for third-party content or links.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">5. Limitation of Liability</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>To the fullest extent permitted by law, we are not liable for indirect, incidental, or consequential damages arising from your use of the site.</li>
                    <li>Our total liability to you is limited to the amount you paid (if any) for accessing the site.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">6. Termination</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We may terminate or suspend your access if you violate these Terms or applicable law.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">7. Governing Law</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>These Terms are governed by the laws of the jurisdiction where we are located, without regard to conflict of law principles.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">8. Changes</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>We may modify these Terms at any time. We will post any changes on this page, and your continued use of the site signifies acceptance.</li>
                </ul>

                <h2 className="text-2xl font-bold mb-4 text-primary">9. Contact Us</h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                    <li>If you have questions about these Terms, please contact us using the information on our site.</li>
                </ul>
            </div>
        </div>
    );
};

export default Terms;